function buttonOutline() {
	const buttons = document.querySelectorAll('.button-outline:not(.button-outline--over-dark)');
	
	buttons.forEach(button => {
		const text = button.innerHTML;
		// wrap text in span
		button.innerHTML = `<span>${text}</span>`;
		// and duplicate the span
		button.innerHTML = button.innerHTML + button.querySelector('span').outerHTML;
	});
}

function buttons(){
	buttonOutline()
}

export default buttons;